import React from 'react'
import { Link } from 'gatsby'
import PropTypes from 'prop-types'

import './PostGrid.scss'
import '../../styles/sonoro.scss'
import { GatsbyImage } from 'gatsby-plugin-image'
import { cleanSlug, getGImage } from '../../helpers'
import { shortenText } from '../../helpers/shortenText'

function PostGrid({
  title = '',
  posts,
  color = '#111',
  linkTo,
  showMoreIcon = false,
  showModalFunction = null,
  showTitle = true,
}) {
  const buildTags = (tags) =>
    tags.nodes.map((t, i) => (
      <b key={t.slug}>
        {i > 0 ? ', ' : '# '}
        {t.name}
      </b>
    ))
  console.log('posts')
  console.log(posts)
  return (
    <div>
      <h1 style={{ fontSize: '18px' }}>{title}</h1>
      <div className='grid'>
        {title !== '' && (
          <div
            className='box-new title'
            style={{ background: color, cursor: 'default' }}
          >
            <h1
              style={{
                textAlign: 'right',
                padding: '0 30px',
                color: 'white',
                textTransform: 'uppercase',
              }}
              className='text -s -bold -right'
            >
              {title.includes(' ')
                ? title.split(' ').map((s, i) => (
                    <React.Fragment key={`${s}-${i + 1}`}>
                      {i > 0 && <br />}
                      {s}
                    </React.Fragment>
                  ))
                : title}
            </h1>
          </div>
        )}

        {posts.map((n) =>
          n.linkTo ? (
            n.linkTo[0] === '/' ? (
              <Link to={n.linkTo} className='box-new' key={n.id}>
                {n.tags && <div className='more-info'>{buildTags(n.tags)}</div>}
                <div className={`grid-box grow full`}>
                  <GatsbyImage
                    image={getGImage(n.featuredImage)}
                    alt={n.title}
                  />
                  {showTitle && (
                    <div className='title'>{shortenText(n.title)}</div>
                  )}
                </div>
              </Link>
            ) : (
              <a
                href={n.linkTo}
                target='_blank'
                className='box-new'
                key={n.id}
                rel='noreferrer'
              >
                {n.tags && <div className='more-info'>{buildTags(n.tags)}</div>}
                <div className={`grid-box grow full`}>
                  {n.featuredImage ? (
                    <GatsbyImage
                      image={getGImage(n.featuredImage)}
                      alt={n.title}
                    />
                  ) : null}
                  {showTitle && (
                    <div className='title'>{shortenText(n.title)}</div>
                  )}
                </div>
              </a>
            )
          ) : showModalFunction ? (
            <div
              className='box-new'
              key={n.id}
              onClick={() => showModalFunction(n)}
            >
              {n.tags && <div className='more-info'>{buildTags(n.tags)}</div>}
              <div className='grid-box grow full'>
                <GatsbyImage image={getGImage(n.featuredImage)} alt={n.title} />
                {showTitle && <div className='title'>{n.title}</div>}
              </div>
            </div>
          ) : (
            <Link
              to={`/post/${cleanSlug(n.slug)}`}
              className='box-new'
              key={n.id}
            >
              {n.tags && <div className='more-info'>{buildTags(n.tags)}</div>}
              <div className={`grid-box grow full`}>
                <GatsbyImage image={getGImage(n.featuredImage)} alt={n.title} />
                {showTitle && (
                  <div className='title'>{shortenText(n.title)}</div>
                )}
              </div>
            </Link>
          )
        )}
        {showMoreIcon && (
          <Link
            to={linkTo}
            className='box-new title'
            style={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              alignContent: 'center',
            }}
          >
            <h1
              style={{
                textAlign: 'center',
                padding: '0 100px',
                fontSize: '100px',
                fontWeight: 'light',
              }}
              className={`text${posts && posts.length ? '' : ' loading'}`}
            >
              +
            </h1>
          </Link>
        )}
      </div>
    </div>
  )
}

PostGrid.propTypes = {
  title: PropTypes.string,
  posts: PropTypes.array,
  selectedOption: PropTypes.object,
  color: PropTypes.string,
  linkTo: PropTypes.string,
  showMoreIcon: PropTypes.bool,
  showModalFunction: PropTypes.func,
  showTitle: PropTypes.bool,
}

export default PostGrid
